var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
var MultiSelectDropdown = /** @class */ (function (_super) {
    __extends(MultiSelectDropdown, _super);
    function MultiSelectDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.onSelectionChange = function (event) {
            //set timeout due to SDDS component data not being loaded
            setTimeout(function () {
                var _a, _b;
                var selectedOption = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.getAttribute("multi-selected-values");
                if (_this.props.onDropdownValueChange) {
                    var selectedOptionAsObject = JSON.parse(selectedOption);
                    _this.props.onDropdownValueChange(selectedOptionAsObject);
                }
            }, 200);
        };
        _this.dataArrayRef = React.createRef();
        return _this;
    }
    MultiSelectDropdown.prototype.componentDidMount = function () {
        var dataArray = this.dataArrayRef.current;
        if (dataArray) {
            dataArray.addEventListener('selectOption', this.onSelectionChange);
        }
    };
    MultiSelectDropdown.prototype.render = function () {
        var _a = this.props, id = _a.id, placeholder = _a.placeholder, options = _a.options, type = _a.type;
        return (React.createElement(React.Fragment, null,
            React.createElement("sdds-dropdown", { id: id, placeholder: placeholder, type: type, ref: this.dataArrayRef }, options.map(function (item) {
                return React.createElement("sdds-dropdown-option", { key: "id-" + item.value, value: item.value }, item.label);
            }))));
    };
    return MultiSelectDropdown;
}(Component));
export default MultiSelectDropdown;
